import React, { forwardRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const ReCaptcha = forwardRef(function ReCaptcha(
  { onChange, error, className = "" },
  ref,
) {
  if (!RECAPTCHA_SITE_KEY) {
    return (
      <p className="text-xs font-medium text-red-600">
        reCAPTCHA is not configured. Set REACT_APP_RECAPTCHA_SITE_KEY.
      </p>
    );
  }

  return (
    <div className={className}>
      <div className="overflow-x-auto">
        <ReCAPTCHA
          ref={ref}
          sitekey={RECAPTCHA_SITE_KEY}
          onChange={(token) => onChange(token || "")}
          onExpired={() => onChange("")}
          onErrored={() => onChange("")}
        />
      </div>
      {typeof error === "string" && error && (
        <p className="mt-1.5 text-xs font-medium text-red-600 animate-fadeIn">
          {error}
        </p>
      )}
    </div>
  );
});

export default ReCaptcha;
